import { VoucherModel } from '../../models/invoicing/voucher.model';
import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {

  constructor(private _httpClient: HttpClient) { }

  getVouchersByAccountingInterface(accountingInterfaceId: number): Observable<Array<VoucherModel>> {
    return this._httpClient.get<Array<VoucherModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.voucher.GetVouchersByAccountingInterface}/${accountingInterfaceId}`);
  }

  getVouchersByAccountingInterfaceId(accountingInterfaceId: number): Observable<CustomTableReport> {
    return this._httpClient.get<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.voucher.GetVouchersByAccountingInterfaceId}/${accountingInterfaceId}`);
  }

  recalculate(accountingInterfaceId: number): Observable<CustomTableReport> {
    return this._httpClient.get<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.voucher.Recalculate}/${accountingInterfaceId}`);
  }

}
